/* eslint-disable react/no-unknown-property */
import useTrans from "@/hooks/useTrans"
import { Container, Stack, Typography } from "@mui/material"
import Image from "next/image"
import React, { useMemo } from "react"

import BeInCryptoLogo from "@/assets/icons/logo-be-in-crypto.png"
import BenzingaLogo from "@/assets/icons/logo-benzinga.png"
import CoinMarketCapLogo from "@/assets/icons/logo-coin-market-cap.png"
import CoinSixEightLogo from "@/assets/icons/logo-coin-six-eight.png"
import CoinspeakerLogo from "@/assets/icons/logo-coinspeaker.png"
import InvestingLogo from "@/assets/icons/logo-investing.png"
import NewsBitconLogo from "@/assets/icons/logo-tap-chi-btc.png"

import FiveMinCryptoLogo from "@/assets/images/logo-5-min-crypto.png"
import AdvfnLogo from "@/assets/images/logo-advfn.png"
import ChainwireLogo from "@/assets/images/logo-chainwire.png"
import CoinCryptoLogo from "@/assets/images/logo-coin.png"
import CryptoIntelligenceLogo from "@/assets/images/logo-crypto-intelligence.png"
import CryptoPotatoLogo from "@/assets/images/logo-crypto-potato.png"
import CryptoSlateLogo from "@/assets/images/logo-crypto-slate.png"
import TechBullionLogo from "@/assets/images/logo-tech-bullion.png"
import TheBitTimesLogo from "@/assets/images/logo-the-bit-times.png"
import TheBlock101Logo from "@/assets/images/logo-the-block-101.png"

const FeaturedIn = () => {
  const trans = useTrans()
  const logos = useMemo(
    () => [
      { src: BeInCryptoLogo, width: 196, height: 31, href: "https://vn.beincrypto.com/ky-gui-vay-token-renec-lend" },
      {
        src: NewsBitconLogo,
        width: 78,
        height: 39,
        href: "https://tapchibitcoin.io/kham-pha-renec-lend-vay-usdt-lai-suat-duoi-5-nhan-airdrop-mien-phi.html",
      },
      {
        src: CoinSixEightLogo,
        width: 83,
        height: 46,
        href: "https://coin68.com/kham-pha-renec-lend-giai-phap-vay-usdt-voi-lai-suat-duoi-5nam-cung-co-hoi-nhan-airdrop-token",
      },
      { src: TheBlock101Logo, width: 106, height: 48, href: "https://theblock101.com/relend-lend-la-gi" },
      {
        src: CoinMarketCapLogo,
        width: 168,
        height: 29,
        href: "https://coinmarketcap.com/community/articles/66f23ca0e40b654eb295983c",
      },
      {
        src: InvestingLogo,
        width: 180,
        height: 32,
        href: "https://www.investing.com/news/cryptocurrency-news/renec-lend-announces-limitedtime-airdrop-event-for-relend-token-rel-3628994",
      },
      {
        src: BenzingaLogo,
        width: 136,
        height: 19,
        href: "https://www.benzinga.com/pressreleases/24/09/40994734/renec-lend-announces-limited-time-airdrop-event-for-relend-token-rel",
      },
      {
        src: AdvfnLogo,
        width: 108,
        height: 52,
        href: "https://www.advfn.com/stock-market/COIN/BTCUSD/crypto-news/94597456/renec-lend-announces-limited-time-airdrop-event-fo",
      },
      {
        src: CryptoPotatoLogo,
        width: 206,
        height: 52,
        href: "https://cryptopotato.com/renec-lend-announces-limited-time-airdrop-event-for-relend-token-rel",
      },
      {
        src: CryptoSlateLogo,
        width: 212,
        height: 52,
        href: "https://cryptoslate.com/press-releases/renec-lend-announces-limited-time-airdrop-event-for-relend-token-rel",
      },
      {
        src: CryptoIntelligenceLogo,
        width: 280,
        height: 32,
        href: "https://www.cryptointelligence.co.uk/renec-lend-announces-limited-time-airdrop-event-for-relend-token-rel",
      },
      { src: TheBitTimesLogo, width: 127, height: 52, href: "https://thebittimes.com/news/single/id/101752" },
      {
        src: ChainwireLogo,
        width: 93,
        height: 42,
        href: "https://chainwire.org/2024/09/24/renec-lend-announces-limited-time-airdrop-event-for-relend-token-rel",
      },
      {
        src: TechBullionLogo,
        width: 149,
        height: 52,
        href: "https://techbullion.com/claim-free-rel-tokens-before-they-hit-the-market-limited-time-airdrop",
      },
      {
        src: CoinspeakerLogo,
        width: 194,
        height: 32,
        href: "https://www.coinspeaker.com/claim-free-rel-tokens-limited-time-airdrop",
      },
      { src: FiveMinCryptoLogo, width: 52, height: 52, href: "https://www.youtube.com/watch?v=7w1VYISm3cU" },
      { src: CoinCryptoLogo, width: 52, height: 52, href: "https://www.youtube.com/watch?v=yt6SRxeZF2E&t=1121s" },
    ],
    [],
  )

  return (
    <Container maxWidth='xl' className='py-6 sm:pt-10 sm:pb-20'>
      <Stack alignItems='center' gap={1}>
        <Typography className='text-neutral-1000 text-center font-montserrat text-2xl sm:text-[2.5rem] font-bold leading-tight'>
          <span>{trans.home.mentioned_by}</span>
        </Typography>
      </Stack>

      <div
        x-data='{}'
        x-init="$nextTick(() => {
                        let ul = $refs.logos;
                        ul.insertAdjacentHTML('afterend', ul.outerHTML);
                        ul.nextSibling.setAttribute('aria-hidden', 'true');
                    })"
        className='group mt-8 w-full inline-flex flex-nowrap overflow-hidden [mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-128px),transparent_100%)]'
      >
        <ul
          x-ref='logos'
          className='flex items-center justify-center md:justify-start [&_li]:mx-8 [&_img]:max-w-none animate-infinite-scroll group-hover:animate-paused'
        >
          {logos.map((logo, index) => (
            <li key={index}>
              <a href={logo.href} target='_blank' rel='noreferrer'>
                <Image src={logo.src} alt='logo' width={logo.width} height={logo.height} />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </Container>
  )
}

export default FeaturedIn
